import { render } from "./SayHi.vue?vue&type=template&id=38787124"
import script from "./SayHi.vue?vue&type=script&lang=js"
export * from "./SayHi.vue?vue&type=script&lang=js"

import "./SayHi.vue?vue&type=style&index=0&id=38787124&lang=css"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__